const BUTTON_TYPES = {
    NORMAL: 'normal',
    SMALL: 'small',
    INVERTED: 'inverted',
    SMALL_INVERTED: 'smallInverted',
    XS: 'extraSmall',
    XS_INVERTED: 'extraSmallInverted',
}

export { BUTTON_TYPES }
